import { linkTypes, targetFroms } from 'json/link-manage'
import { getEnumeration } from 'enumeration'
export default {
  linkTrackOfAll (data) {
    data.forEach(item => {
      item.object_type = getEnumeration(item.objectType, linkTypes)
      item.from_channel = getEnumeration(item.from, targetFroms)
    })
    return data
  }
}
